import React from 'react'
import ContactForm from './ContactForm'

const HomeContactUs = () => {
  return (
   <>
   <ContactForm />
   </>
  )
}

export default HomeContactUs